import { render, staticRenderFns } from "./InboxDetails.vue?vue&type=template&id=28975fae&scoped=true&"
import script from "./InboxDetails.vue?vue&type=script&lang=js&"
export * from "./InboxDetails.vue?vue&type=script&lang=js&"
import style0 from "./InboxDetails.vue?vue&type=style&index=0&id=28975fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28975fae",
  null
  
)

export default component.exports